// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubmitButton_wrapper__vWipv","button":"SubmitButton_button__3W5KF"};